import useAppQueryParam from "@/hooks/useAppQueryParam";
import useAppTranslation from "@/services/i18n/useAppTranslation";
import useAppStore from "@/store/app-store";
import { useEffect } from "react";

const useAppLanguage = () => {
  const setAppLang = useAppStore((state) => state.setAppLang);
  const { setLocale } = useAppTranslation();
  const { getQueryParam } = useAppQueryParam();

  // Get lang from query params
  const lang = getQueryParam("lang");

  useEffect(() => {
    if (lang) {
      setAppLang(lang);
      setLocale(lang);
    } else {
      setAppLang("en");
      setLocale("en");
    }
  }, [lang]);

  return { lang };
};

export default useAppLanguage;
